// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"0b280d1c","182":"64345176","805":"4da3ab21","833":"7084dac4","837":"f0f11e85","846":"c567a92b"}[chunkId] + ".chunk.js";
};